export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6402.7f912405.jpg";